import React from 'react';
import { useApolloClient } from '@apollo/client';

import Button, { BUTTON_WIDTHS } from 'buyside/components/presentation/Button/button';

import { ideaSearchUrl } from 'buyside/util/urlHelper';

import { IdeaPositionsQuery } from 'interfaces/graphql-typings';

const IdeaPositions = require('buyside/graphql/queries/ideaShowPage/IdeaPositions');

import styles from './entityIdeasStyles.scss';

const EntityIdeas: React.FC<{
  ideaId: string;
}> = ({ ideaId }) => {
  const client = useApolloClient();

  const cachedPosIdea = client.readQuery<IdeaPositionsQuery>({
    query: IdeaPositions,
    variables: { ideaId }
  })?.idea;

  if (!cachedPosIdea || !cachedPosIdea.hasEntitiesHaveOtherIdeas) return null;

  return (
    <>
      {cachedPosIdea?.positions?.map(position => (
        <Button
          key={position.id}
          className={styles.entityIdeasLink}
          text={`More research on ${position.asset?.symbol ||
            position.asset?.entity.name ||
            'this security'}`}
          url={ideaSearchUrl(`ticker=${position.asset?.symbol}`)}
          width={BUTTON_WIDTHS.FULL}
          target="_blank"
        />
      ))}
    </>
  );
};

export default EntityIdeas;
